import React from 'react'

const PreviousBtn = ({ onClick = () => {}}) => {
  return (
    <div className="flex items-center justify-between">
      <button className="mr-2" onClick={onClick}>
        <svg
          className="w-6 h-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
    </div>
  )
}

export default PreviousBtn



// WEBPACK FOOTER //
// src/components/previousBtn/PreviousBtn.js